import React from "react";
import "./Errors.css"



const Errors=()=>{
    return(
        
        <div className="card posE" >
            <h1>Error: 404</h1>
            <h2>Lost your track?</h2>
            <h3>No worries. You can track the flow of your money</h3>
            <h4><a href="/" className="a12">Click here to get back on track</a></h4> 
        </div>
    )
}
export default Errors;